import { ReactNode } from "react";

import { Language } from "../../../../../../../../../services";
import { getDefaultColumnLabelCellHelpers } from "../../../../../../../../../utils";
import {
	ColumnId,
	translationTablePath,
} from "../../../../../../../../../constants/tables/accountsExecutors";

import fullName from "./fullName";
import alias from "./alias";
import parkNumber from "./parkNumber";
import taxId from "./taxId";
import phones from "./phones";
import balance from "./balance";
import bonusBalance from "./bonusBalance";
import role from "./role";
import company from "./company";
import taxiService from "./taxiService";
import registeredAt from "./registeredAt";
import responsibleDispatcher from "./responsibleDispatcher";
import executorRateId from "./executorRateId";
import priority from "./priority";
import executorTeamId from "./executorTeamId";
import electronicReceipts from "./electronicReceipts";
import note from "./note";

export interface Column {
	render: (options: Column.Options) => ReactNode;
	label: string | string[];
}

export declare namespace Column {
	interface Options {
		width?: number;
		language: Language;
		onResize?: (width: number, columnId: ColumnId) => void;
	}
}

const createLabel = (id: ColumnId): [string, string] => [
	`${translationTablePath}${id}`,
	getDefaultColumnLabelCellHelpers(id),
];

export const columns: Record<ColumnId, Column> = {
	[ColumnId.FullName]: {
		render: fullName,
		label: createLabel(ColumnId.FullName),
	},
	[ColumnId.Alias]: {
		render: alias,
		label: createLabel(ColumnId.Alias),
	},
	[ColumnId.ParkNumber]: {
		render: parkNumber,
		label: createLabel(ColumnId.ParkNumber),
	},
	[ColumnId.TaxId]: {
		render: taxId,
		label: createLabel(ColumnId.TaxId),
	},
	[ColumnId.Phones]: {
		render: phones,
		label: createLabel(ColumnId.Phones),
	},
	[ColumnId.Balance]: {
		render: balance,
		label: createLabel(ColumnId.Balance),
	},
	[ColumnId.BonusBalance]: {
		render: bonusBalance,
		label: createLabel(ColumnId.BonusBalance),
	},
	[ColumnId.Role]: {
		render: role,
		label: createLabel(ColumnId.Role),
	},
	[ColumnId.ExecutorTeamId]: {
		render: executorTeamId,
		label: createLabel(ColumnId.ExecutorTeamId),
	},
	[ColumnId.Company]: {
		render: company,
		label: createLabel(ColumnId.Company),
	},
	[ColumnId.TaxiService]: {
		render: taxiService,
		label: createLabel(ColumnId.TaxiService),
	},
	[ColumnId.RegisteredAt]: {
		render: registeredAt,
		label: createLabel(ColumnId.RegisteredAt),
	},
	[ColumnId.ResponsibleDispatcher]: {
		render: responsibleDispatcher,
		label: createLabel(ColumnId.ResponsibleDispatcher),
	},
	[ColumnId.ExecutorRateId]: {
		render: executorRateId,
		label: createLabel(ColumnId.ExecutorRateId),
	},
	[ColumnId.Priority]: {
		render: priority,
		label: createLabel(ColumnId.Priority),
	},
	[ColumnId.ElectronicReceipts]: {
		render: electronicReceipts,
		label: createLabel(ColumnId.ElectronicReceipts),
	},
	[ColumnId.Notes]: {
		render: note,
		label: createLabel(ColumnId.Notes),
	},
};

export const defaultColumnIds = [
	ColumnId.FullName,
	ColumnId.Alias,
	ColumnId.ParkNumber,
	ColumnId.TaxId,
	ColumnId.Phones,
	ColumnId.Balance,
	ColumnId.BonusBalance,
	ColumnId.Role,
	ColumnId.ExecutorTeamId,
	ColumnId.Company,
	ColumnId.TaxiService,
	ColumnId.RegisteredAt,
	ColumnId.ResponsibleDispatcher,
	ColumnId.ExecutorRateId,
	ColumnId.Priority,
	ColumnId.ElectronicReceipts,
	ColumnId.Notes,
];

export const disabledColumnsIds = [];

export { ColumnId };

export default columns;
